// Grobe Restzeit-Schätzung für eine laufende Generierung.
// createdAt: Startzeitpunkt des Jobs (vom Backend).
// avgSec: Durchschnittsdauer abgeschlossener Jobs (vom Backend), Fallback 4 Min.
// Eine exakte ETA gibt es nicht, weil die Kette unterschiedlich viele Prüf-/
// Überarbeitungs-Runden macht — daher bewusst „ca.".
export function generationEta(createdAt, avgSec) {
  if (!createdAt) return { text: "", pct: 0 };
  const avg = Number(avgSec) > 0 ? Number(avgSec) : 240;
  const elapsed = Math.max(0, (Date.now() - new Date(createdAt).getTime()) / 1000);
  const remaining = avg - elapsed;
  const pct = Math.max(0.03, Math.min(0.97, elapsed / avg));
  let text;
  if (remaining <= 20) text = "fast fertig …";
  else if (remaining < 90) text = "noch unter 1 Min";
  else text = `noch ca. ${Math.ceil(remaining / 60)} Min`;
  return { text, pct };
}
